import { Controller } from "@hotwired/stimulus"

// curator-stream
// Manages the live streaming status stack for the Curator.
// Monitors #curator-status-stack for appended chips:
//   - Newest chip slides up with fade-in (.curator-chip-enter)
//   - When stack exceeds MAX_VISIBLE (3), oldest slides up and
//     fades out (.curator-chip-exit), then is removed after
//     EXIT_ANIMATION_MS
//   - Every mutation is logged with [curator-stream] prefix
export default class extends Controller {
  static MAX_VISIBLE = 3
  static ENTER_ANIMATION_MS = 400
  static EXIT_ANIMATION_MS = 400

  connect() {
    console.log(`[curator-stream] connect`)
    this.observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === "childList") {
          for (const node of mutation.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE && node.matches(".curator-progress-chip")) {
              this.chipAdded(node)
            }
          }
        }
      }
    })
    this.observer.observe(this.element, { childList: true })

    this.element.querySelectorAll(".curator-progress-chip").forEach((chip) => {
      chip.classList.add("curator-chip-enter")
    })
    this.enforceMax()
  }

  chipAdded(chip) {
    chip.classList.add("curator-chip-enter")
    console.log(`[curator-stream] chip added: "${this.chipLabel(chip)}"`)
    setTimeout(() => this.enforceMax(), this.constructor.ENTER_ANIMATION_MS + 50)
  }

  enforceMax() {
    // Single pass: chips already exiting still sit in the DOM until their
    // removal timer fires, so count only non-exiting chips and mark the
    // excess. (The old while-loop re-queried the DOM synchronously — the
    // deferred removal could never run while it spun, so >MAX chips hung
    // the tab in an infinite loop.)
    const max = this.constructor.MAX_VISIBLE
    const chips = [...this.element.querySelectorAll(".curator-progress-chip:not(.curator-chip-exit)")]
    const excess = chips.length - max

    for (let i = 0; i < excess; i++) {
      const oldest = chips[i]
      console.log(`[curator-stream] removing oldest: "${this.chipLabel(oldest)}"`)
      oldest.classList.remove("curator-chip-enter")
      oldest.classList.add("curator-chip-exit")
      setTimeout(() => {
        if (oldest.parentNode) oldest.remove()
      }, this.constructor.EXIT_ANIMATION_MS)
    }
  }

  chipLabel(el) {
    return el.dataset.message || el.textContent?.trim().slice(0, 40) || "(empty)"
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
    console.log(`[curator-stream] disconnect`)
  }
}
